import React from "react";
import { Line } from "react-chartjs-2";
import { Box, Card } from "@material-ui/core";
import momentJalali from "moment-jalaali";

const options = {
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",

      // grid line settings
      grid: {
        drawOnChartArea: false, // only want the grid lines for one axis to show up
      },
    },
  },
};

class PersonAmar extends React.Component {
  constructor(props) {
    super(props);
    momentJalali.loadPersian([
      {
        usePersianDigits: false,
      },
    ]);
    const { amar } = this.props;
    const dataAmar = JSON.parse(amar);

    const now = momentJalali().subtract(12, "jMonth");
    const dates = [];
    for (let i = 0; i < 15; i++) {
      dates.push(now.add(1, "jMonth").format("jYYYY-jMM"));
    }

    let data = {
      labels: dates,
      datasets: [
        {
          type: "line",
          label: "# چک پاس شده",
          data: dates.map((d) => {
            return dataAmar.cheques_cashed_count[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgba(255, 99, 132, 0.2)",
          yAxisID: "y",
        },
        {
          type: "line",

          label: "# چک برگشتی",
          data: dates.map((d) => {
            return dataAmar.cheques_bounced_count[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(255, 29, 10)",
          borderColor: "rgba(255, 29, 10, 0.2)",
          yAxisID: "y",
        },
        {
          type: "line",

          label: "# سایر",
          data: dates.map((d) => {
            return dataAmar.cheques_other_count[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(10, 20, 132)",
          borderColor: "rgba(10, 20, 132, 0.2)",
          yAxisID: "y",
        },
        {
          type: "bar",
          label: "# چک پاس شده",
          data: dates.map((d) => {
            return dataAmar.cheques_cashed_sum[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgba(255, 99, 132, 0.2)",
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: "# چک برگشتی",
          data: dates.map((d) => {
            return dataAmar.cheques_bounced_sum[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(255, 29, 10)",
          borderColor: "rgba(255, 29, 10, 0.2)",
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: "# سایر",
          data: dates.map((d) => {
            return dataAmar.cheques_other_sum[d] ?? 0;
          }),
          fill: false,
          backgroundColor: "rgb(10, 20, 132)",
          borderColor: "rgba(10, 20, 132, 0.2)",
          yAxisID: "y1",
        },
      ],
    };

    this.state = {
      data,
    };
  }

  render() {
    return (
      <Card>
        <div className="header">
          <h1 className="title">نمودار عملکرد</h1>
        </div>
        <Box p={5}>
          <Line data={this.state.data} options={options} />
        </Box>
      </Card>
    );
  }
}

export default PersonAmar;
